import { ServerCrash } from 'lucide-react';

import { useServiceIssuesBanner } from '@/hooks/ui/banners/useServiceIssuesBanner';
import { PageBanner } from './PageBanner';

/**
 * The service-issues strip — ROUTE_INVENTORY Part 1, G8. Tone: destructive
 * (the backend is failing requests). `role='alert'`: the app misbehaving is
 * worth interrupting for.
 *
 * `ServiceIssuesBannerView` is the strip; `ServiceIssuesBanner` wires it to
 * `useServiceIssuesBanner`, standalone. In the app it is shown by
 * `features/shell/ShellBanners`.
 */
export function ServiceIssuesBannerView({
  onDismiss,
}: {
  onDismiss: () => void;
}) {
  return (
    <PageBanner
      tone='destructive'
      icon={ServerCrash}
      message='Service issues detected.'
      detail="Some things may not work right now. We're on it."
      onDismiss={onDismiss}
      dismissLabel='Dismiss service-issues banner'
      live='alert'
    />
  );
}

export function ServiceIssuesBanner() {
  const { raised, dismissed, dismiss } = useServiceIssuesBanner();
  if (!raised || dismissed) return null;
  return <ServiceIssuesBannerView onDismiss={dismiss} />;
}
